@let currentStatusValue = currentStatus();
@let currentConfigValue = config[currentStatusValue];

<div class="text">
  <div class="heading">
    <rt-heading>
      {{ currentConfigValue.heading }}
    </rt-heading>
    <rt-badge
      [color]="currentConfigValue.badge.color"
      [text]="currentConfigValue.badge.text"
      margin-left-small-xx
    ></rt-badge>
  </div>
  <div class="description">
    {{ currentConfigValue.description }}
  </div>
</div>
<div class="actions">
  <rt-button
    (click)="actionClicked.emit(currentStatusValue)"
    [variant]="currentConfigValue.cta.variant"
  >
    <rt-icon [name]="currentConfigValue.cta.icon" />
    <span>{{ currentConfigValue.cta.text }}</span>
  </rt-button>
</div>
